<app-section-quick-actions section="item" />

<header class="atmos-page__header">
  <h1 class="atmos-page__title">Dye previews</h1>
</header>

<p class="atmos-paragraph">
  This page shows dye previews for items that support dyeing. You can view more details on the item page by clicking on an item below.
</p>

<app-item-grid-layout [items]="items" [itemTemplate]="dyeTpl" [initialCategory]="initialCategory"/>
<ng-template #dyeTpl let-item>
  <a class="atmos-item-dye__item atmos-tile"
     [routerLink]="['/item', item.guid]"
     [skyTooltip]="item.name" [attr.aria-label]="item.name">
    <img class="atmos-item-dye__img atmos-img-box" [src]="item.dye!.previewUrl" loading="lazy" draggable="false"/>
    <app-icon class="atmos-item-dye__icon"
              [src]="item.icon || '/assets/icons/question.webp'"
              width="64px" height="64px"
              [lazy]="true" [draggable]="false">
    </app-icon>
    <app-item-subicons [item]="item" [icons]="SUBICONS_ALL" [size]="24"/>
  </a>
</ng-template>
